import moduleConfig from './module-config';

export default angular
  .module('app.init', [])
  .config(['$stateProvider', moduleConfig]);
